import Image from 'next/image';
import checkoutCards from '@/public/images/cards.png';

// Mirrors production's #cart-secure-checkout row. The card marks are the same
// single asset production serves, not a redrawing of the official network logos.
// Vertical spacing is left to the caller so each breakpoint can set its own.
const LockIcon = () => (
  <svg
    className="h-5"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M32 9c-7 0-13 6-13 13v5c-2 1-4 3-4 6v16a6 6 0 0 0 6 6h22a6 6 0 0 0 6-6V33a6 6 0 0 0-4-6v-5c0-7-6-13-13-13zm0 4c5 0 9 4 9 9v5H23v-5c0-5 4-9 9-9zM21 31h22a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H21a2 2 0 0 1-2-2V33a2 2 0 0 1 2-2z" />
  </svg>
);

const SecureCheckoutBadges = ({ className = '' }) => (
  <div className={`flex items-center justify-center gap-4 text-primary ${className}`}>
    <div className="font-worksans flex items-center gap-1 text-xs font-normal">
      <LockIcon />
      Secure Checkout
    </div>

    <Image
      src={checkoutCards}
      alt="Visa, Mastercard, American Express and Discover accepted"
      className="w-32 h-auto"
      sizes="128px"
    />
  </div>
);

export default SecureCheckoutBadges;
